import {Text} from '@mantine/core';
import React from 'react';

import InlineBanner, {InlineBannerActionType, InlineBannerType} from 'ui-library/banners/InlineBanner';
import {ButtonStyle} from 'ui-library/buttons/Button';

export const RESYNC_BANNER_TITLE = 'This table has outdated values';
export const RESYNC_BANNER_SUBTITLE =
  'One or more cells no longer reflect the latest linked data. Review and confirm outdated values and then re-sync before submitting.';
export const RESYNC_BANNER_BUTTON_TEXT = 'Re-sync';

export const REACTION_DIAGRAM_RESYNC_BANNER_TITLE = 'Reaction diagram is out of date';
export const REACTION_DIAGRAM_RESYNC_BANNER_SUBTITLE =
  'The table has changed since this diagram was generated. Re-sync diagram to apply the latest changes.';
export const REACTION_DIAGRAM_RESYNC_BANNER_BUTTON_TEXT = 'Re-sync diagram';

export interface ResyncReactionTableBannerProps {
  onResyncClick: () => void;
  title?: string;
  subtitle?: string;
  actionText?: string;
  dataTestAttrs?: {component: string; element?: string};
}

export default function ResyncReactionTableBanner({
  onResyncClick,
  title = RESYNC_BANNER_TITLE,
  subtitle = RESYNC_BANNER_SUBTITLE,
  actionText = RESYNC_BANNER_BUTTON_TEXT,
  dataTestAttrs = {component: 'StoichiometryGroupView', element: 'resyncBanner'},
}: ResyncReactionTableBannerProps): JSX.Element {
  return (
    <InlineBanner
      bannerType={InlineBannerType.INFO}
      text={
        <>
          <span>{title}</span>
          <br />
          <Text component="span" weight={400}>
            {subtitle}
          </Text>
        </>
      }
      action={{
        actionType: InlineBannerActionType.CUSTOM,
        actionText,
        actionOnClick: onResyncClick,
        buttonStyle: ButtonStyle.TERTIARY_BLUE,
        rightAlign: true,
      }}
      dataTestAttrs={dataTestAttrs}
    />
  );
}
